// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as PaymentModeType from "../../../../app/order/entity/PaymentModeType.bs.js";
import * as NLOrderPaymentVm from "./vm-mapper/NLOrderPaymentVm.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var info_icon = OrderDashboardAssetsManager.getImage("info.svg");

function NLOrderPaymentInfo$PaymentMode(Props) {
  var payment_mode = Props.payment_mode;
  return React.createElement("p", {
              className: "payment-mode"
            }, "PAYMENT MODE : " + PaymentModeType.toString(payment_mode).toUpperCase());
}

var PaymentMode = {
  make: NLOrderPaymentInfo$PaymentMode
};

function getViewLabel(payment_info) {
  return {
          hd: {
            label: "Fare Payable",
            value: {
              TAG: /* Text */0,
              _0: payment_info.fare_payable
            }
          },
          tl: {
            hd: {
              label: "Amount paid by Instamojo",
              value: {
                TAG: /* Text */0,
                _0: payment_info.instamojo_amount
              }
            },
            tl: {
              hd: {
                label: "Actual Driver Collected Cash",
                value: {
                  TAG: /* Text */0,
                  _0: payment_info.driver_collected_cash
                }
              },
              tl: {
                hd: {
                  label: "Amount paid by Razorpay",
                  value: {
                    TAG: /* Text */0,
                    _0: payment_info.razorpay_amount
                  }
                },
                tl: {
                  hd: {
                    label: "Cashback",
                    value: {
                      TAG: /* Text */0,
                      _0: payment_info.cashback
                    }
                  },
                  tl: {
                    hd: {
                      label: "Amount paid by Paytm",
                      value: {
                        TAG: /* Text */0,
                        _0: payment_info.paytm_amount
                      }
                    },
                    tl: {
                      hd: {
                        label: "Porter Credits",
                        value: {
                          TAG: /* Text */0,
                          _0: payment_info.porter_credits
                        }
                      },
                      tl: {
                        hd: {
                          label: "Business Account Charges",
                          value: {
                            TAG: /* Text */0,
                            _0: payment_info.business_account
                          }
                        },
                        tl: {
                          hd: {
                            label: "Amount paid by Muneemji",
                            value: {
                              TAG: /* Text */0,
                              _0: payment_info.muneemji
                            }
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderPaymentInfo(Props) {
  var order_fare = Props.order_fare;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var payment_info = NLOrderPaymentVm.getVm(order_fare, currency);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement("div", {
                                className: "payment-information-card-title-wrapper"
                              }, React.createElement(CardTitleWithImage.make, {
                                    title: "Payment Information",
                                    icon_src: info_icon
                                  }), React.createElement(NLOrderPaymentInfo$PaymentMode, {
                                    payment_mode: order_fare.payment_mode
                                  }));
                  })
              },
              action: undefined,
              className: "primary-info-card payment-info",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(payment_info))
                  })
            });
}

var make = NLOrderPaymentInfo;

export {
  info_icon ,
  PaymentMode ,
  getViewLabel ,
  make ,
  
}
/* info_icon Not a pure module */
